"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _commonComponents = require("../../commonComponents");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTranslated = require("../../hooks/useTranslated");

var _excluded = ["render", "deleteButtonIcon"];

var Controls = _styledComponents["default"].div.withConfig({
  displayName: "deleteButton__Controls"
})(["grid-column:2;grid-row:1;"]); // Giving the delete button an implicit confirmation


var DeleteButton = function DeleteButton(_ref) {
  var _ref$render = _ref.render,
      render = _ref$render === void 0 ? undefined : _ref$render,
      deleteButtonIcon = _ref.deleteButtonIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var deleteConfirm = (0, _useTranslated.useTranslated)('components.deleteButton.confirmation');
  return /*#__PURE__*/_react["default"].createElement(Controls, {
    className: "row_controls"
  }, /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerButton, (0, _extends2["default"])({}, props, {
    onClick: function onClick() {
      var result = window.confirm(deleteConfirm);

      if (result) {
        props.onClick();
      }
    }
  }), deleteButtonIcon), render && render());
};

DeleteButton.defaultProps = {
  deleteButtonIcon: "\u2716"
};
var _default = DeleteButton;
exports["default"] = _default;